/**
 * Google Ads Product Recommendations - Optimized Version
 * 
 * Performance optimizations:
 * - No jQuery dependency (vanilla JS)
 * - Uses pre-computed API URL from data attribute (no DOM search delay)
 * - Exits immediately for non-Google traffic (zero overhead)
 * - Single fetch call (no retry timeouts)
 * - Deferred script loading
 */
(function() {
    'use strict';

    // Check for Google/Bing Ads traffic IMMEDIATELY - exit fast for regular traffic
    var params = new URLSearchParams(window.location.search);
    var utmSource = (params.get('utm_source') || '').toLowerCase();
    var hasUtmCampaign = params.has('utm_campaign');
    var allowedSources = ['google', 'bing', 'facebook', 'meta'];
    if (!allowedSources.includes(utmSource) && !hasUtmCampaign) {
        //console.log('[sg-product] Google Ads: top slider skipped — no allowed source or campaign found');
        return; // Require an allowed source or the presence of utm_campaign.
    }

    //console.log('[sg-product] Paid Ads traffic detected (' + utmSource + ') — loading recommendations');

    // Get the API URL from the script tag's data attribute (pre-computed by Liquid)
    var scriptTag = document.currentScript || document.querySelector('script[data-recs-url]');
    var apiUrl = scriptTag ? scriptTag.getAttribute('data-recs-url') : null;

    // Fallback: try to find it in DOM if data attribute not available
    if (!apiUrl) {
        var recsBlock = document.querySelector('[data-recommendations-block][data-url]');
        if (recsBlock) {
            apiUrl = recsBlock.getAttribute('data-url');
        }
    }

    if (!apiUrl) {
        //console.log('[sg-product] Google Ads: no recommendations URL found');
        return;
    }

    /** Number of complementary products below which we also append related products. */
    var MIN_SLIDES_BEFORE_RELATED = 8;

    /**
     * Extract the product link URL from a slide so related products can be
     * de-duplicated against complementary products already shown.
     */
    function getProductUrl(slideEl) {
        var link = slideEl.querySelector('a[href*="/products/"]');
        var href = link ? link.getAttribute('href') : null;
        if (!href) return null;

        try {
            var productUrl = new URL(href, window.location.origin);
            var path = productUrl.pathname.replace(/\/+$/, '');
            return path || '/';
        } catch (error) {
            return href.split(/[?#]/)[0].replace(/\/+$/, '') || '/';
        }
    }

    /**
     * Append source slides into the Google Ads swiper wrapper.
     * @param {HTMLElement} swiperEl The top slider swiper element.
     * @param {NodeList|Array} sourceSlides Slides to append.
     * @param {boolean} clone Whether source nodes should be cloned before appending.
     * @param {Set} skipUrls Optional set of product URLs to skip (de-duplication).
     * @returns {number} Number of slides actually appended.
     */
    function appendSlides(swiperEl, sourceSlides, clone, skipUrls) {
        var targetWrapper = swiperEl.querySelector('.swiper-wrapper');
        if (!targetWrapper) return 0;

        var added = 0;
        sourceSlides.forEach(function(slide, index) {
            // Wrap in swiper-slide if not already
            var slideEl;
            if (slide.classList && slide.classList.contains('swiper-slide')) {
                slideEl = clone ? slide.cloneNode(true) : slide;
            } else {
                slideEl = document.createElement('div');
                slideEl.className = 'swiper-slide';
                slideEl.appendChild(clone ? slide.cloneNode(true) : slide);
            }

            if (skipUrls) {
                var url = getProductUrl(slideEl);
                if (url && skipUrls.has(url)) {
                    //console.log('[sg-product] Google Ads: skipping duplicate product — ' + url);
                    return;
                }
                if (url) {
                    skipUrls.add(url);
                }
            }

            targetWrapper.appendChild(slideEl);
            added++;

            var productTitle = slideEl.querySelector('.card-title a, .card-information__text a, .product-card-title a, h3 a, h2 a');
            var titleText = productTitle ? productTitle.textContent.trim() : '(unknown)';
            //console.log('[sg-product] Google Ads ' + (clone ? 'clone' : 'move') + ': card #' + (index + 1) + ' — ' + titleText);
        });

        return added;
    }

    /**
     * Set the header text, reveal the wrapper and initialize the top Swiper.
     * Returns false without rendering when no product slides are available.
     */
    function initTopSwiper(wrapper, swiperEl, headerText, loop) {
        var slideCount = swiperEl.querySelectorAll('.swiper-wrapper > .swiper-slide').length;
        if (slideCount === 0) {
            hideTopSwiper(wrapper, swiperEl);
            return false;
        }

        // Prepend/update the header before the swiper element
        var headerDiv = wrapper.querySelector('.fdp-google-ads-slider-header');
        if (!headerDiv) {
            headerDiv = document.createElement('div');
            headerDiv.className = 'fdp-google-ads-slider-header';
            swiperEl.parentNode.insertBefore(headerDiv, swiperEl);
        }
        headerDiv.innerHTML = '<span class="h2">' + headerText + '</span>';

        // Show the wrapper
        wrapper.style.display = 'block';
        wrapper.dataset.fetching = 'false';

        // Initialize Swiper
        if (typeof Swiper !== 'undefined') {
            new Swiper(swiperEl, {
                slidesPerView: 'auto',
                speed: 600,
                loop: loop,
                spaceBetween: 12,
                //grabCursor: true,
                pagination: {
                    el: swiperEl.querySelector('.swiper-pagination'),
                    clickable: true,
                    enabled: true,
                },
                navigation: {
                    nextEl: swiperEl.querySelector('.swiper-button-next'),
                    prevEl: swiperEl.querySelector('.swiper-button-prev'),
                    enabled: false,
                },
                breakpoints: {
                    551: {
                        pagination: {
                            enabled: false,
                        },
                        navigation: {
                            enabled: true,
                        }
                    }
                }
            });
            //console.log('[sg-product] Google Ads Swiper initialized (loop=' + loop + ')');
        } else {
           //console.warn('[sg-product] Google Ads: Swiper library not loaded; rendering static product cards');
        }

        return true;
    }

    /**
     * Hide the Google Ads slider when there are no products to display.
     * Do not initialize Swiper for an empty wrapper.
     */
    function hideTopSwiper(wrapper, swiperEl) {
        var targetWrapper = swiperEl.querySelector('.swiper-wrapper');
        if (targetWrapper) {
            targetWrapper.innerHTML = '';
        }

        var headerDiv = wrapper.querySelector('.fdp-google-ads-slider-header');
        if (headerDiv) {
            headerDiv.remove();
        }

        wrapper.style.display = 'none';
        wrapper.dataset.fetching = 'false';
       // console.log('[sg-product] Google Ads: no complementary or related products — top slider hidden');
    }

    /**
     * Fetch recommendations and append them as related products after the
     * complementary products already present in the top slider.
     */
    function fetchAndAppendRelated(wrapper, swiperEl, headerText, skipUrls, loop) {
        //console.log('[sg-product] Google Ads: fetching related products (loop=' + loop + ')');

        fetch(apiUrl)
            .then(function(response) {
                if (!response.ok) throw new Error('HTTP ' + response.status);
                return response.text();
            })
            .then(function(html) {
                // Parse the HTML response
                var parser = new DOMParser();
                var doc = parser.parseFromString(html, 'text/html');

                // Find swiper slides from the PRODUCT recommendations swiper
                var sourceSlides = doc.querySelectorAll('.fdp-products-recommendations-swiper .swiper-slide');
                //console.log('[sg-product] Google Ads: found ' + sourceSlides.length + ' slides in .fdp-products-recommendations-swiper');

                if (sourceSlides.length === 0) {
                    // Fallback: try .halo-recommendations-block .swiper-slide
                    sourceSlides = doc.querySelectorAll('.halo-recommendations-block .swiper-slide');
                    //console.log('[sg-product] Google Ads: fallback .halo-recommendations-block .swiper-slide — ' + sourceSlides.length + ' found');
                }

                if (sourceSlides.length === 0) {
                    // Last fallback: try any .product inside recommendations block
                    sourceSlides = doc.querySelectorAll('.halo-recommendations-block .product');
                    //console.log('[sg-product] Google Ads: last fallback .halo-recommendations-block .product — ' + sourceSlides.length + ' found');
                }

                if (sourceSlides.length === 0) {
                    // Fallback for product-card markup without a slide or product wrapper.
                    sourceSlides = doc.querySelectorAll('.halo-recommendations-block .product-item');
                    //console.log('[sg-product] Google Ads: fallback .halo-recommendations-block .product-item — ' + sourceSlides.length + ' found');
                }

                if (sourceSlides.length === 0) {
                    var existingSlideCount = swiperEl.querySelectorAll('.swiper-wrapper > .swiper-slide').length;
                    if (existingSlideCount > 0) {
                        wrapper.dataset.fetching = 'false';
                        initTopSwiper(wrapper, swiperEl, headerText, loop);
                    } else {
                        hideTopSwiper(wrapper, swiperEl);
                    }
                    return;
                }

                var relatedCount = appendSlides(swiperEl, sourceSlides, true, skipUrls);
                var totalSlideCount = swiperEl.querySelectorAll('.swiper-wrapper > .swiper-slide').length;
                if (totalSlideCount > 0) {
                    wrapper.dataset.fetching = 'false';
                    initTopSwiper(wrapper, swiperEl, headerText, loop);
                    //console.log('[sg-product] Google Ads Swiper initialized with ' + relatedCount + ' related slides appended');
                } else {
                    hideTopSwiper(wrapper, swiperEl);
                }
            })
            .catch(function(err) {
                //console.error('[sg-product] Google Ads: fetch failed —', err);
                var existingSlideCount = swiperEl.querySelectorAll('.swiper-wrapper > .swiper-slide').length;
                if (existingSlideCount > 0) {
                    wrapper.dataset.fetching = 'false';
                    initTopSwiper(wrapper, swiperEl, headerText, loop);
                } else {
                    hideTopSwiper(wrapper, swiperEl);
                }
            });
    }

    /**
     * Loop-disabled flow: display cloned complementary products first,
     * then append related products when there are fewer than MIN_SLIDES_BEFORE_RELATED.
     */
    function initComplementaryAndRelated(wrapper, swiperEl, complementarySlides, headerText) {
        var targetWrapper = swiperEl.querySelector('.swiper-wrapper');
        if (!targetWrapper) return;
        targetWrapper.innerHTML = '';

        var skipUrls = new Set();
        var complementaryCount = appendSlides(swiperEl, complementarySlides, true, skipUrls);

        if (complementaryCount < MIN_SLIDES_BEFORE_RELATED) {
            fetchAndAppendRelated(wrapper, swiperEl, headerText, skipUrls, false);
        } else {
            initTopSwiper(wrapper, swiperEl, headerText, false);
            //console.log('[sg-product] Google Ads Swiper initialized with ' + complementaryCount + ' complementary slides (loop disabled)');
        }
    }

    /**
     * Loop-enabled (default) flow: clone product cards into the Google Ads swiper.
     */
    function renderClonedSlides(wrapper, swiperEl, sourceSlides, headerText) {
        var targetWrapper = swiperEl.querySelector('.swiper-wrapper');
        if (!targetWrapper) return;
        targetWrapper.innerHTML = '';

        var count = appendSlides(swiperEl, sourceSlides, true, null);
        initTopSwiper(wrapper, swiperEl, headerText, true);
       // console.log('[sg-product] Google Ads Swiper initialized with ' + count + ' slides');
    }

    /**
     * Determine whether the related-products section is rendered and can be
     * fetched. Loading placeholders count because Shopify replaces them with
     * real product cards asynchronously.
     */
    function hasRelatedProductsOnPage() {
        var recommendationsBlock = document.querySelector('[data-recommendations-block]');
        if (!recommendationsBlock) return false;

        return recommendationsBlock.querySelectorAll('.product-item--loadingNoInfo, .product-item:not(.product-item--loadingNoInfo) a[href*="/products/"]').length > 0;
    }

    /**
     * Initialize the Google Ads Swiper with cloned product cards
     */
    function initGoogleAdsSwiperClone() {
        var wrapper = document.getElementById('fdp-google-ads-clone');
        if (!wrapper) {
           // console.log('[sg-product] Google Ads: wrapper element not found');
            return;
        }

        var swiperEl = wrapper.querySelector('.fdp-google-ads-swiper-clone');
        if (!swiperEl) return;

        // Already initialized?
        if (swiperEl.swiper) return;

        // Already fetching?
        if (wrapper.dataset.fetching === 'true') return;

        // Mark as fetching
        wrapper.dataset.fetching = 'true';

        // Check whether the complementary products slider has looping disabled.
        var complementarySwiperEl = document.querySelector('#complementary-product-data .complementary-products-swiper');
        var disableLoop = complementarySwiperEl && complementarySwiperEl.getAttribute('data-disable-loop') === 'true';

        // First, check if the product already has complementary products rendered
        // on the page (.complementary-products-slider inside #complementary-product-data).
        var complementarySlider = document.querySelector('#complementary-product-data .complementary-products-slider');
        var complementarySlides = complementarySlider ? complementarySlider.querySelectorAll('.swiper-slide') : [];
        var relatedProductsAvailable = hasRelatedProductsOnPage();

       // console.log('[sg-product] Google Ads: complementary slides=' + complementarySlides.length + ', related products available=' + relatedProductsAvailable);

        if (disableLoop) {
            // Loop is disabled: show cloned complementary products first,
            // then append related products when there are fewer than 8 of them.
           // console.log('[sg-product] Google Ads: loop disabled — combining complementary + related products');

            if (complementarySlides.length > 0) {
                if (relatedProductsAvailable) {
                    initComplementaryAndRelated(wrapper, swiperEl, complementarySlides, 'Customers Also Viewed');
                } else {
                    var complementaryOnlyUrls = new Set();
                    var complementaryOnlyCount = appendSlides(swiperEl, complementarySlides, true, complementaryOnlyUrls);
                    if (complementaryOnlyCount > 0) {
                        initTopSwiper(wrapper, swiperEl, 'Customers Also Viewed', false);
                    } else {
                        hideTopSwiper(wrapper, swiperEl);
                    }
                }
            } else if (relatedProductsAvailable) {
                fetchAndAppendRelated(wrapper, swiperEl, 'Customers Also Viewed', new Set(), false);
            } else {
                hideTopSwiper(wrapper, swiperEl);
            }
            return;
        }

        if (complementarySlides.length > 0) {
            //console.log('[sg-product] Google Ads: found ' + complementarySlides.length + ' complementary product slide(s) — using complementary products instead of fetching recommendations');

            renderClonedSlides(wrapper, swiperEl, complementarySlides, 'Customers Also Viewed');
            return;
        }

        if (relatedProductsAvailable) {
           // console.log('[sg-product] Google Ads: no complementary products found — fetching recommendations from: ' + apiUrl);
            fetchAndAppendRelated(wrapper, swiperEl, 'Customers Also Viewed', new Set(), true);
        } else {
            hideTopSwiper(wrapper, swiperEl);
        }
    }

    // Run when DOM is ready (script is deferred, so DOM should be ready)
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initGoogleAdsSwiperClone);
    } else {
        // DOM already ready, run immediately
        initGoogleAdsSwiperClone();
    }

})();
